export default __webpack_public_path__ + "static/media/social_fb.6f2904a9.svg";